import { useMcpTool } from 'webmcp-react'
import { EnumUserRoles } from 'entities/Users/model/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { computeComplianceStatus } from 'entities/WebMcp/lib/complianceStatus'
import { serializeComplianceStatus } from 'entities/WebMcp/lib/serializers'
import { getComplianceStatusSchema } from 'entities/WebMcp/model/schemas'
import {
  COMPLIANCE_TOOL_DESCRIPTION,
  COMPLIANCE_GUIDANCE,
} from 'entities/WebMcp/model/complianceToolText'
import { escalationMessage } from 'entities/WebMcp/model/roleGating'
import { okResult, errorResult } from 'entities/WebMcp/lib/toolResult'

/**
 * Registers get_compliance_status (global). Renders nothing. Gated to owner and
 * admin, matching `navigate` and the Compliance page's own access layout.
 */
export const ComplianceTools = () => {
  const { usersStore, featureFlagsStore } = useEntitiesContext()

  useMcpTool({
    name: 'get_compliance_status',
    description: COMPLIANCE_TOOL_DESCRIPTION,
    input: getComplianceStatusSchema,
    annotations: { readOnlyHint: true },
    handler: async () => {
      try {
        // Fails closed while the role is unhydrated, so an early prompt cannot read.
        const role = usersStore.user?.role ?? EnumUserRoles.VIEW_ONLY
        if (role !== EnumUserRoles.OWNER && role !== EnumUserRoles.ADMIN) {
          return okResult({ escalation: escalationMessage(role, 'compliance') })
        }

        const status = await computeComplianceStatus({
          rcsAvailable: featureFlagsStore.canManageRCS,
          isUKCountry: Boolean(usersStore.user?.isUKCountry),
        })
        return okResult(serializeComplianceStatus(status), COMPLIANCE_GUIDANCE)
      } catch (e) {
        return errorResult(e)
      }
    },
  })

  return null
}
